import { useParams, Navigate } from "react-router-dom";

/**
 * Legacy WordPress URL shim: `/hypnosex/:file.htm` → `/blog/:slug`.
 *
 * The old site served every blog post at `/hypnosex/<slug>.htm`. React
 * Router matches the file name as a single param that still carries the
 * trailing ".htm" - we strip it and 302 to the new canonical path.
 *
 * A proper 301 lives in Cloudflare Redirect Rules; this is a client-side
 * safety net so direct hits in-browser still land correctly before a
 * crawler ever sees them.
 */
export default function LegacyBlogRedirect() {
  const { file } = useParams();
  const slug = (file || "").replace(/\.html?$/i, "");
  if (!slug) return <Navigate to="/blog" replace />;
  return <Navigate to={`/blog/${slug}`} replace />;
}
